// NOTE: Dependencies: jQuery
// NOTE: This module MUST run first

(function ($) {
  $.fn.lmTabs = function (options) {
    // check is dom element is defined
    if (!this.length) {
      return false;
    }

    // Default settings are set here.
    var settings = $.extend({
      noJs: 'no-js',
      js: 'js',
      document: document,
      $document: $(document),
      $body: $('body'),
      bodyRestrain: 'body--restrain',
      bodyAnimating: 'body--animating',
      tabs: '.tabs',
      tabNav: '.tab-nav',
      tabNavItem: '.tab-nav__item',
      tabNavItemActive: 'tab-nav__item--active',
      tabNavLink: '.tab-nav__link',
      tabContent: '.tab-content',
      tabContentActive: 'tab-content--active'
    }, options);

    // These are all the methods available for the plugin.
    var methods = {};

    methods.setCurrentSettings = function ($context) {
      var currentSettings = $context.data();

      if (!$.isEmptyObject(currentSettings)) {
        $context.data($.extend({}, settings, currentSettings));
      } else {
        $context.data(settings);
      }

      // Initialize item.
      $context.data('initialized', true);
    };

    // Bind events
    methods.events = function () {
      // Top bar button click toggles the class
      $(settings.tabNavLink).off('click.lmTabs').on('click.lmTabs', function (event) {
        var $this = $(this);
        event.preventDefault();
        methods.toggleTabContent($this);
      });
    };

    // Display selected tab content
    methods.toggleTabContent = function ($this) {
      var tabContent = $this.attr('href'),
        $tabContent = $(tabContent),
        $tabNavItem = $this.parent(settings.tabNavItem),
        $allTabNavItems = $(settings.tabNavItem),
        $allTabContent = $(settings.tabContent);

      if (!$tabContent.hasClass(settings.tabContentActive)) {
        $allTabNavItems.removeClass(settings.tabNavItemActive);
        $tabNavItem.addClass(settings.tabNavItemActive);

        // Check if tabs have a slider
        if ($tabContent.find('.slider').length) {
          var $slider = $tabContent.find('.slider');

          // Destroy and reinit slider
          $slider.slick('unslick');
          setTimeout(function () {
            $slider.slick({
              mobileFirst: true
            });
          }, 100);
          // Set classes
          $this.addClass(settings.tabSelectorActive);
          $allTabContent.removeClass(settings.tabContentActive);
          $tabContent.addClass(settings.tabContentActive);

        } else {
          $this.addClass(settings.tabSelectorActive);
          $allTabContent.removeClass(settings.tabContentActive);
          $tabContent.addClass(settings.tabContentActive);
        }

      }
    };

    // Filter each function.
    methods.filterEach = function () {
      return !$(this).data('initialized');
    };

    // Run once methods when jquery plugin is called.
    methods.events(this);

    // Methods to run inside loop.
    return this.filter(methods.filterEach).each(function () {
      $(this).attr('data-initialized', true);
    });
  };

  // Attach and run code
  if ($('.tab-nav').length) {
    $('.tab-nav').lmTabs();
  }

}(jQuery));